const baseApi = {
  fapi: `${process.env.VUE_APP_ADMIN_API_NEW}/api`,
  napi: `${process.env.VUE_APP_ADMIN_API_NEW}/xapi`
}

export default baseApi
